/**
 * Legal metadata for web documents — keep aligned with `mobile/src/lib/legal-constants.ts`.
 */
export const LEGAL_LAST_UPDATED = "August 10, 2026";
export const LEGAL_APP_NAME = "Alenio";
export const LEGAL_COMPANY_NAME = "Alenio Insights, LLC";
export const LEGAL_PARENT_COMPANY_NAME = "Lott Technologies Group, LLC";
export const LEGAL_WEBSITE_LABEL = "alenio.com";
export const LEGAL_CONTACT_EMAIL = "info@alenio.com";
